// extracted by mini-css-extract-plugin
module.exports = {"CardSections":"Recipe_CardSections__3AOzQ"};